/**
 * JALRAKSHAK Interactive Anomaly Simulator
 * Allows live demonstration of normal vs contaminated water states.
 */

import { SIMULATION_SCENARIOS, SENSORS_CONFIG } from '../data/sensorsData.js';
import { initWqiGauge } from './dashboard.js';

export function initSimulator() {
  const scenarioButtons = document.querySelectorAll('.scenario-btn');
  const alertBanner = document.querySelector('.sim-alert-banner');
  const asvActionText = document.querySelector('.sim-asv-action-text');

  scenarioButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const scenarioKey = btn.dataset.scenario;
      if (!scenarioKey || !SIMULATION_SCENARIOS[scenarioKey]) return;

      scenarioButtons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      applyScenario(scenarioKey);
    });
  });

  function applyScenario(key) {
    const scenario = SIMULATION_SCENARIOS[key];
    if (!scenario) return;

    // Update WQI Gauge
    initWqiGauge(scenario.wqi);

    // Update Alert Banner
    if (alertBanner) {
      alertBanner.className = `sim-alert-banner ${scenario.alertLevel}`;
      alertBanner.innerHTML = `
        <span class="pulse-dot"></span>
        <span><strong>${scenario.status}:</strong> ${scenario.alert}</span>
      `;
    }

    // Update ASV Action text
    if (asvActionText) {
      asvActionText.textContent = scenario.asvAction;
    }

    // Update Parameter Cards
    Object.keys(scenario.values).forEach(paramId => {
      const val = scenario.values[paramId];
      const valEl = document.getElementById(`sensor-val-${paramId}`);
      if (valEl) {
        valEl.textContent = val;
      }

      // Update status badge on card
      const badgeEl = document.getElementById(`sensor-badge-${paramId}`);
      if (badgeEl) {
        const config = SENSORS_CONFIG.find(s => s.id === paramId);
        if (config) {
          if (val < config.optimalMin || val > config.optimalMax) {
            badgeEl.className = 'badge badge-danger';
            badgeEl.textContent = 'Anomaly';
          } else {
            badgeEl.className = 'badge badge-green';
            badgeEl.textContent = config.status;
          }
        }
      }
    });
  }
}
